import React, { useState } from 'react'
import AsyncSelect from 'react-select/async'
import debounce from 'debounce-promise'
import { useConfig } from '@peracto/peracto-config'
import axios from 'axios'
import styled from 'styled-components'

import ContentProductRelationshipsList from './ContentProductRelationshipsList'

const FilterToggle = styled.div`
    button {
        appearance: none;
        border: 1px solid #6c757d;
        color: #6c757d;
        height: 20px;
        font-size: 12px;
        background-color: transparent;

        &:active,
        &:focus {
            outline: none;
        }

        &.selected {
            background-color: #6c757d;
            color: #ddd;
        }

        &:first-child {
            border-radius: 3px 0 0 3px;
        }

        &:last-child {
            border-radius: 0 3px 3px 0;
        }
    }
`

const ContentProductRelationships = ({ settings, setSettings }) => {
    const config = useConfig()
    const API_URL = config.get('api')
    const [selectedFilter, setSelectedFilter] = useState('productName')

    const fetchProducts = async input => {
        const { data } = await axios.get(`${API_URL}/products?${selectedFilter}=${input || ''}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        })

        const selectedProducts = settings.contentProductLinks.map(product => {
            return product.hasOwnProperty('product') ? product.product['@id'] : product['@id']
        })

        const parsedData = data['hydra:member'].filter(
            product => !selectedProducts.includes(product['@id'])
        )

        const values = parsedData.map(product => ({
            label: `${product.name} <${product.sku}>`,
            value: product,
        }))

        return values
    }

    const debouncedFetchProducts = debounce(fetchProducts, 200)

    return (
        <div data-testid={`related-products-section`}>
            <div className="!flex !justify-between !mt-2">
                <label>Related Products</label>

                <div className="!flex">
                    <span className="!mr-2">Filter by:</span>
                    <FilterToggle>
                        <button
                            onClick={() => setSelectedFilter('productName')}
                            className={selectedFilter === 'productName' ? 'selected' : ''}
                            data-testid="filter-name"
                        >
                            Name
                        </button>
                        <button
                            onClick={() => setSelectedFilter('sku')}
                            className={selectedFilter === 'sku' ? 'selected' : ''}
                            data-testid="filter-sku"
                        >
                            SKU
                        </button>
                    </FilterToggle>
                </div>
            </div>

            <div data-testid="related-dropdown">
                <AsyncSelect
                    className="!w-full content-product-relatonship-select"
                    loadOptions={input => debouncedFetchProducts(input)}
                    isSearchable={true}
                    value={null}
                    onChange={option => {
                        setSettings({
                            ...settings,
                            contentProductLinks: [...settings.contentProductLinks, option.value],
                        })
                    }}
                    placeholder="Select a product..."
                    classNamePrefix="peracto-select"
                    noOptionsMessage={({ inputValue }) => {
                        if (inputValue.length > 0) {
                            return `No products found for '${inputValue}'.`
                        } else {
                            return 'Enter text to begin searching.'
                        }
                    }}
                />
            </div>

            <ContentProductRelationshipsList settings={settings} setSettings={setSettings} />
        </div>
    )
}

export default ContentProductRelationships
